import React from 'react';
import { MfaMethodType, MFA_METHOD_CONFIGS } from '../graphql/mfa';
import {
  Item,
  ItemMedia,
  ItemContent,
  ItemTitle,
  ItemDescription,
  ItemFooter,
} from '@repo/ui/Item';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
type ButtonComponentType = React.ComponentType<any>;

export interface MfaMethodCardProps {
  type: MfaMethodType;
  enabled: boolean;
  phoneNumber?: string;
  onEnable: () => void;
  onDisable: () => void;
  ButtonComponent: ButtonComponentType;
  hideEnableButton?: boolean;
}

export function MfaMethodCard({
  type,
  enabled,
  phoneNumber,
  onEnable,
  onDisable,
  ButtonComponent,
  hideEnableButton,
}: MfaMethodCardProps) {
  const config = MFA_METHOD_CONFIGS[type];

  return (
    <Item>
      <ItemMedia className="flex justify-center items-center w-10 h-10 bg-blue-100 rounded-lg dark:bg-blue-900">
        <span className="text-blue-600 material-symbols-outlined dark:text-blue-400">
          {config.icon}
        </span>
      </ItemMedia>
      <ItemContent>
        <ItemTitle>
          {config.label}
          {enabled && (
            <span className="inline-flex items-center gap-1 px-2 py-0.5 text-xs font-medium rounded-full bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-200!">
              <span className="text-xs material-symbols-outlined">check_circle</span>
              Enabled
            </span>
          )}
        </ItemTitle>
        <ItemDescription>
          {config.description}
          {type === 'sms' && enabled && phoneNumber && (
            <span className="block mt-1 text-grey-500 dark:text-grey-400">
              Phone: {phoneNumber}
            </span>
          )}
        </ItemDescription>
      </ItemContent>
      <ItemFooter className="justify-end">
        {enabled ? (
          <ButtonComponent type="button" variant="danger-secondary" size="sm" onClick={onDisable}>
            Disable
          </ButtonComponent>
        ) : !hideEnableButton ? (
          <ButtonComponent type="button" variant="secondary" size="sm" onClick={onEnable}>
            Enable
          </ButtonComponent>
        ) : null}
      </ItemFooter>
    </Item>
  );
}
